import EE from 'eventemitter3';
import settings from '~/utils/Settings';

// эти события будут проигнорированы
// при наличии флага DS_ANALYTICS_ENABLED в настройках
const dsEvents = new Set([
  'screen-resolution',
  'cpu-info',
  'media-devices',
  'ram',
  'battery-info',
  'screen-orientation',
  'color-depth',
  'browser-window-size',
  'touchscreen-support',
  'cookies-status',
  'graphics',
  'browser-language',
  'device-type',
  'page-load-time',
  'added-to-cart-click',
  'removed-item-click',
  'create-order-button-click',
  'move-to-item-details-click',
  'successful-order-click',
  'unsuccessful-order-click',
]);

const ignoreDsAnalytics = (type: string) => {
  // @ts-ignore
  const { DS_ANALYTICS_ENABLED } = settings.settingsMapping;

  return !DS_ANALYTICS_ENABLED && dsEvents.has(type);
};

const decorator = (func: any) =>
  function () {
    const eventType = arguments[1].type;

    if (ignoreDsAnalytics(eventType)) {
      return;
    }

    // @ts-ignore
    return func.call(this, ...arguments);
  };

class EventEmitter extends EE {
  constructor() {
    super();

    this.emit = decorator(this.emit);
  }
}

export default EventEmitter;
